import React, {useEffect, useState} from "react";
import {Box, Skeleton} from "@mui/material";
import Analytics from "../../libs/analytics";
const PHOTO_SX = {
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};

const IMAGE_SX = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center"
};
const PhotoView = ({src, photo}) => {
    const [current, setCurrent] = useState(photo.id);
    const [initialized, setInitialized] = useState(false);
    const [bgReady, setBgReady] = useState(false);
    useEffect(()=>{
        if( current !== photo.id){
            setCurrent(photo.id);
            Analytics.photoView(photo);
        }
    },[src, photo])
    useEffect(() => {
        if (!initialized) {
            setInitialized(true);
            Analytics.photoView(photo);
        }
    }, [src, photo])
    return <Box sx={PHOTO_SX}>
        <Box component="img" sx={IMAGE_SX} src={src} alt={photo.title || ""} onLoad={()=>setBgReady(true)} />
        { !bgReady && <Box position={"absolute"} bottom={0} right={0} top={0} left={0} paddingTop={"100%"} bgcolor={"#ffffff"}>
            <Skeleton width={"100%"} height={'100%'} sx={{position: 'absolute', top:0}} variant={'rectangular'} animation={"wave"} />
        </Box>}
    </Box>
}
export default PhotoView;